/* app/js/src/components/outpost/remote/outpost-remote.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.remote-container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
}
.remote-container .body {
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin-left: 220px;
  overflow: hidden;
}
.remote-container .body::-webkit-scrollbar {
  display: none;
}
.remote-container .body .body-iframe {
  margin: 50px 50px 50px 50px;
  width: calc(100vw - 50px - 50px - 220px);
  height: calc(100vh - 70px - 54px - 50px - 50px);
  scrollbar-width: none;
  -ms-overflow-style: none;
  background: rgb(235, 240, 244);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
  border: none;
  overflow: hidden;
}
.remote-container .body .body-iframe::-webkit-scrollbar {
  display: none;
}
/*# sourceMappingURL=outpost-remote.component.css.map */
